import React, { useState } from "react";
import { X, Rocket, Loader2 } from "lucide-react";

const toLocal = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
};
const input = "w-full rounded-xl border border-gray-200 px-3 py-2.5 text-sm outline-none focus:border-[#2ec9c9]";

export const LaunchDialog = ({ holiday, busy, onClose, onLaunch }) => {
  const [start, setStart] = useState("");
  const [end, setEnd] = useState(toLocal(holiday.ends_at));
  const eventDay = new Date(`${holiday.date}T09:00:00`);
  const daysBefore = (n) => {
    const d = new Date(eventDay.getTime() - n * 86400000);
    setStart(d > new Date() ? toLocal(d.toISOString()) : "");
  };
  const submit = (e) => {
    e.preventDefault();
    onLaunch({ starts_at: start ? new Date(start).toISOString() : "", ends_at: end ? new Date(end).toISOString() : "" });
  };
  const bad = start && end && new Date(start) >= new Date(end);
  return (
    <div className="fixed inset-0 z-[90] bg-black/50 flex items-center justify-center p-4" onClick={onClose}>
      <form onSubmit={submit} onClick={(e) => e.stopPropagation()} className="bg-white rounded-2xl w-full max-w-[460px] p-6 space-y-4" data-testid="launch-dialog">
        <div className="flex items-center justify-between">
          <h3 className="font-semibold text-[#16243b]">Launch {holiday.label} promo</h3>
          <button type="button" onClick={onClose}><X size={18} className="text-[#5a6b80]" /></button>
        </div>
        <div className="rounded-xl px-4 py-3 text-sm font-semibold" style={{ background: holiday.bg_color, color: holiday.text_color }}>{holiday.text}</div>
        <div>
          <p className="text-xs text-[#5a6b80] mb-1.5">Go live</p>
          <div className="flex flex-wrap gap-2 mb-2">
            <button type="button" onClick={() => setStart("")} data-testid="launch-now" className={`rounded-full px-3 py-1.5 text-xs font-medium border ${!start ? "bg-[#16243b] text-white border-[#16243b]" : "border-gray-200 text-[#5a6b80]"}`}>Now</button>
            {[3, 7, 14].map((n) => (
              <button type="button" key={n} onClick={() => daysBefore(n)} data-testid={`launch-${n}-days`} className="rounded-full px-3 py-1.5 text-xs font-medium border border-gray-200 text-[#5a6b80] hover:border-[#2ec9c9]">{n} days before</button>
            ))}
          </div>
          <input type="datetime-local" value={start} onChange={(e) => setStart(e.target.value)} data-testid="launch-starts-at" className={input} />
        </div>
        <label className="block text-xs text-[#5a6b80]">Switch off
          <input type="datetime-local" value={end} onChange={(e) => setEnd(e.target.value)} data-testid="launch-ends-at" className={`${input} mt-1.5`} />
        </label>
        {bad && <p className="text-xs text-red-500">The end must be after the start.</p>}
        <button disabled={busy || bad} data-testid="launch-confirm" className="gp-btn-teal w-full rounded-xl py-3 font-medium flex items-center justify-center gap-2 disabled:opacity-60">
          {busy ? <Loader2 size={16} className="animate-spin" /> : <Rocket size={16} />} {start ? "Schedule promo" : "Launch now"}
        </button>
      </form>
    </div>
  );
};
